import { useShowMessage, useUserDetails } from '@pepper/ui'

import { useSelectedCompanyId } from 'utils/functions/misc'
import { OrgModalType } from 'container/Dashboard/Dashboard'

const useOrganisations = (
  user: User,
  setJoinOrganisationModal?: (args: OrgModalType) => void
) => {
  const companyId = useSelectedCompanyId()
  const message = useShowMessage()
  const { userDetails } = useUserDetails(user.uid)

  const companies = userDetails?.companies
    .filter(company => !!company.company_name)
    .sort((a: Company, b: Company) =>
      a.company_name!.localeCompare(b.company_name!)
    )

  const activeCompany: Company | undefined = companies?.find(
    company => company.id === companyId
  )

  const handleOnMenuItemClick = async (company: Company) => {
    try {
      if (company.invite_id) {
        setJoinOrganisationModal?.({
          visible: true,
          data: {
            id: company.id,
            company_name: company.company_name as string,
            invite_id: company.invite_id,
          },
        })
        return
      }
      localStorage.setItem('isJustLoggedIn', 'true')
      window.localStorage.removeItem('domain_id')
      window.location.href = `/${company.id}/home`
    } catch (error) {
      message({ type: 'error', message: error.message })
    }
  }

  return {
    selectedCompany: activeCompany,
    allCompanies: companies,
    onSelect: handleOnMenuItemClick,
  }
}

export default useOrganisations
